import axios from "./configs/axiosConfig";

export const postContactUs = async (contactdata) => {
  const url = `contactus`;
  return await axios.post(url, contactdata);
};
